export default function UserIcon({ size = 16, color: _, filled: _1, ...props }: IconProps) {
  return (
    <svg width={size} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="13" cy="13" r="13" fill="#E9E9F4" />
      <path
        d="M18.2854 17.926C18.6648 17.8469 18.8908 17.4499 18.7022 17.1112C18.2866 16.3647 17.6318 15.7086 16.7941 15.2087C15.7152 14.5648 14.3933 14.2158 13.0334 14.2158C11.6735 14.2158 10.3517 14.5648 9.2728 15.2087C8.4351 15.7086 7.78027 16.3647 7.3646 17.1112C7.17605 17.4499 7.40204 17.8469 7.78148 17.926C11.2456 18.648 14.8213 18.648 18.2854 17.926Z"
        fill="#272733"
      />
      <circle cx="13.0335" cy="9.4112" r="3.43195" fill="#272733" />
    </svg>
  );
}
